import type {UnverifiedLinkedLiterary} from 'schemaDefinition/types';
import type {ManifestationExternalSuggestions} from 'services/metadata/types';

export const externalSuggestionsToLinkedLiteraries = (
  externalSuggestions: ManifestationExternalSuggestions[],
): UnverifiedLinkedLiterary[] => {
  const linkedLiteraries: UnverifiedLinkedLiterary[] = [];
  externalSuggestions.forEach(({externalSuggestions}) => {
    (externalSuggestions.seriesTitles ?? []).forEach((value, index) => {
      linkedLiteraries.push({
        link: {
          linkStatus: 'unverified',
          name: value,
        },
        numberInSeries: externalSuggestions.seriesNumbers?.[index],
      });
    });
  });

  return linkedLiteraries;
};
